import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Global cache Symbol for server instances
 * Using Symbol.for() ensures multiple library copies share the same cache
 */
var SERVER_CACHE_SYMBOL = Symbol.for('__requestIframeServerCache__');

/**
 * Get the server cache from window
 */
function getServerCacheForWindow(win) {
  if (!(SERVER_CACHE_SYMBOL in win)) {
    win[SERVER_CACHE_SYMBOL] = new Map();
  }
  return win[SERVER_CACHE_SYMBOL];
}

/**
 * Generate server cache key
 * Cache key format: "secretKey:id" or "secretKey:" when no id
 */
function getServerCacheKey(secretKey, id) {
  return `${secretKey !== null && secretKey !== void 0 ? secretKey : ''}:${id !== null && id !== void 0 ? id : ''}`;
}

/**
 * Get cached server instance or null
 * @param secretKey secret key for message isolation
 * @param id server instance ID
 */
export function getCachedServer(secretKey, id) {
  if (!id) return null;
  var cache = getServerCacheForWindow(window);
  var key = getServerCacheKey(secretKey, id);
  return cache.get(key) || null;
}

/**
 * Cache server instance
 * @param server server instance
 * @param secretKey secret key for message isolation
 * @param id server instance ID
 */
export function cacheServer(server, secretKey, id) {
  if (!id) return;
  var cache = getServerCacheForWindow(window);
  var key = getServerCacheKey(secretKey, id);
  cache.set(key, server);
}

/**
 * Remove server from cache
 * @param secretKey secret key for message isolation
 * @param id server instance ID
 */
export function removeCachedServer(secretKey, id) {
  if (!id) return;
  var cache = getServerCacheForWindow(window);
  var key = getServerCacheKey(secretKey, id);
  cache.delete(key);
}

/**
 * Clear server cache (mainly for testing).
 *
 * - No args: clear all cached servers
 * - With secretKey: only clear servers under that secretKey
 * - With { secretKey, id }: only clear the specified server instance
 * - With { id }: clear the specified id across all secretKeys
 */
export function clearServerCache(arg) {
  var cache = getServerCacheForWindow(window);
  if (!arg) {
    cache.forEach(server => {
      server.destroy();
    });
    cache.clear();
    return;
  }
  var params = typeof arg === 'string' ? {
    secretKey: arg
  } : arg;
  var prefix = typeof params.secretKey === 'string' ? `${params.secretKey}:` : undefined;
  var suffix = typeof params.id === 'string' ? `:${params.id}` : undefined;
  cache.forEach((server, key) => {
    if (prefix && !key.startsWith(prefix)) return;
    if (suffix && !key.endsWith(suffix)) return;
    cache.delete(key);
    server.destroy();
  });
}